<template>
  <div class="stock-customers-page">
    <section class="hero-banner">
      <div class="banner-content">
        <div class="text-content">
          <h1 class="brand-name">红土证券</h1>
          <h2 class="main-title">基金客户</h2>
          <a :href="resolveLink(externalLinks.openAccount)" target="_blank" rel="noopener noreferrer" class="cta-button inline-block">立即开户</a>
        </div>
      </div>
    </section>

    <section class="longbridge-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">基金客户优势</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz1.png" alt="低费率">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">专业投研团队与定制化产品，专注绝对收益与策略多样性</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz2.png" alt="专业工具">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">通过组合配置降低单一市场波动影响，提升整体风险调整后收益。</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz3.png" class="w-13 h-13" alt="广泛市场">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">全球化多元策略布局，捕捉跨市场机遇</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz4.png" alt="便捷出入金">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">严格合规管理与多重风控体系，保障资产与信息安全</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz5.png" alt="个性化服务">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">投研持续迭代与策略优化，紧跟市场变化与机会演进</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz5.png" alt="安全保障">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">多层次投资者适当性管理，精准匹配风险偏好合规持牌 规范运营</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="exclusive-privileges py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="privilege-cards">
            <img src="@/assets/eb285a4109fc4c517f02d5a626d0cb5d.jpg" alt="股票客户特权">
          </div>
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">基金客户专享服务</h3>
            <ul class="space-y-4 mb-6">
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">依托香港市场优势，协助客户实现全球化多元配置，并提供税务结构建议</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">符合国际标准的基金架构，合作知名托管行，确保资产隔离与运作透明</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">专注服务符合资格的专业投资者，提供机构级服务标准与响应机制</span>
              </li>
            </ul>

            <a :href="resolveLink(externalLinks.privilegeLearnMore)" target="_blank" rel="noopener noreferrer" class="bg-[#ef7c5b] cursor-pointer inline-block text-white px-8 py-2 rounded-3xl font-semibold transition-colors">了解详情</a>
          </div>
        </div>
      </div>
    </section>

    <section class="investor-tools py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">卓越的资产管理实力</h3>
            <ul class="space-y-6">
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">专业资产管理优势</p>
                  <p class="text-gray-700 leading-relaxed">依托香港证监会第9类牌照，为高净值客户与机构提供合规、稳健的资产管理服务。</p>
                </div>
              </li>
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">多元策略配置</p>
                  <p class="text-gray-700 leading-relaxed">覆盖境外债券、宏观配置等多策略产品线，投研持续优化，灵活捕捉市场机会。</p>
                </div>
              </li>
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">合规持牌运营</p>
                  <p class="text-gray-700 leading-relaxed">严格遵循香港证监会规管要求，保障资金安全与运作透明。</p>
                </div>
              </li>
            </ul>
            <a :href="resolveLink(externalLinks.investorTools)" target="_blank" rel="noopener noreferrer" class="bg-[#ef7c5b] cursor-pointer inline-block text-white px-8 py-2 mt-4 rounded-3xl font-semibold transition-colors">了解详情</a>
          </div>
          <div class="phone-showcase flex justify-center">
            <img src="@/assets/512b49715c3cd53ac4f12cd6a1560aaf.jpg" alt="工具展示">
          </div>
        </div>
      </div>
    </section>

    <section class="tech-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="mb-6">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">专业的基金投资与资产管理服务</h2>
          <p class="text-base text-gray-800 mt-2">我们凭借香港证监会颁发的第1类（证券交易）、第4类（就证券提供意见）、第9类（资产管理）牌照，为客户提供全面合规、专业专注的基金投资与资产配置解决方案。</p>
        </div>
        <div class="flex gap-6 mb-6 items-center text-gray-600">
          <button v-for="tab in techTabs" :key="tab.key" class="nav-tab" :class="{ active: currentTechTab===tab.key }" @click="currentTechTab=tab.key">{{ tab.label }}</button>
        </div>
        <div class="border-b border-gray-200 mb-8"></div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
          <div class="tech-card">
            <div class="tech-card-body">
              <div class="tech-title">{{ currentTech.cardLeft.title }}</div>
              <div class="tech-subtitle">{{ currentTech.cardLeft.subtitle }}</div>
            </div>
          </div>
          <div class="tech-card">
            <div class="tech-card-body">
              <div class="tech-title">{{ currentTech.cardRight.title }}</div>
              <div class="tech-subtitle">{{ currentTech.cardRight.subtitle }}</div>
            </div>
          </div>
        </div>
        <p class="text-gray-800 mb-4">{{ currentTech.intro }}</p>
        <ul class="space-y-6 mb-8">
          <li v-for="(adv, idx) in currentTech.advantages" :key="idx" class="flex items-start">
            <span class="advantage-icon-box">
              <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#ef7c5b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle v-if="idx===0" cx="12" cy="12" r="3"/>
                <path v-if="idx===0" d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009.4 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 01-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9.4a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z"/>
                <path v-if="idx===1" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                <template v-if="idx===2">
                  <rect x="3" y="3" width="18" height="14" rx="2" ry="2"/>
                  <path d="M7 19h10M9 7l2 2 4-4"/>
                </template>
              </svg>
            </span>
            <span class="text-gray-800">{{ adv }}</span>
          </li>
        </ul>
        <div class="text-center">
          <a :href="resolveLink(externalLinks.techLearnMore)" target="_blank" rel="noopener noreferrer" class="learn-more-btn inline-block">了解更多</a>
        </div>
        <div class="mt-8 text-center text-gray-500">值得信赖的证券经纪服务商</div>
      </div>
    </section>

    <section class="trading-capabilities py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">强大的投资能力</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb1.png" class="w-13 h-13" alt="全终端覆盖">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">全终端覆盖</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 桌面端、移动端一致体验</li>
                  <li>• 随时管理您的基金投资组合</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb2.png" class="w-13 h-13" alt="多市场覆盖">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">多市场覆盖</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 投资于全球股票、债券、另类资产等多种标的</li>
                  <li>• 实现真正多元分散</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb3.png" class="w-13 h-13" alt="实时监控">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">实时监控</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 市场动态与事件提醒</li>
                  <li>• 把握交易机会</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb4.png" class="w-13 h-13" alt="专业研究支持">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">专业研究支持</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 资深研究团队深度分析</li>
                  <li>• 策略与选股建议</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb5.png" class="w-13 h-13" alt="风控保障">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">风控保障</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 多维风险识别与预警</li>
                  <li>• 持仓与资金安全保护</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb6.png" class="w-13 h-13" alt="合规保障">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">合规保障</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 严格合规流程</li>
                  <li>• 审计追踪与隐私保护</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="trusted-broker py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-6">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">专业合规的资产管理伙伴</h2>
          <p class="text-base text-gray-800 max-w-3xl mx-auto mt-3">业合规安全的服务体系，为您的财富保驾护航</p>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <div class="service-card bg-white rounded-lg p-6 shadow-sm">
            <div class="icon-top flex items-center justify-center mb-4">
              <img src="/assets/zh11.png" alt="资产安全保障">
            </div>
            <h4 class="text-lg font-semibold text-gray-900 mb-3 text-center">资产安全保障</h4>
            <ul class="text-gray-700 list-none space-y-3">
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>客户资产独立托管</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>严格风控审核</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>多重安全防护</span></li>
            </ul>
          </div>
          <div class="service-card bg-white rounded-lg p-6 shadow-sm">
            <div class="icon-top flex items-center justify-center mb-4">
              <img src="/assets/zh22.png" alt="数据安全与隐私">
            </div>
            <h4 class="text-lg font-semibold text-gray-900 mb-3 text-center">数据安全与隐私</h4>
            <ul class="text-gray-700 list-none space-y-3">
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>加密传输与存储</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>严格隐私保护政策</span></li>
            </ul>
          </div>
          <div class="service-card bg-white rounded-lg p-6 shadow-sm">
            <div class="icon-top flex items-center justify-center mb-4">
              <img src="/assets/zh33.png" alt="专业服务团队">
            </div>
            <h4 class="text-lg font-semibold text-gray-900 mb-3 text-center">专业服务团队</h4>
            <ul class="text-gray-700 list-none space-y-3">
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>资深投顾与客服支持</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>7×24小时客户服务</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>个性化策略建议</span></li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="account-types py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 text-center">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">支持账户类型</h2>
        <p class="text-base text-gray-800 mb-8">个人与机构均可开立股票账户</p>
        <div class="flex items-center justify-center gap-12 mb-6">
          <div class="flex flex-col items-center">
            <img src="/assets/khd2.png" alt="个人账户">
            <div class="text-gray-900">个人账户</div>
          </div>
          <div class="flex flex-col items-center">
            <img src="/assets/khd2.png" alt="机构账户">
            <div class="text-gray-900">机构账户</div>
          </div>
        </div>
        <div class="max-w-3xl mx-auto border border-gray-200 rounded-lg p-6 bg-white text-left">
          <h4 class="font-semibold text-gray-900 mb-2">开立机构账户</h4>
          <p class="text-gray-700 text-sm leading-relaxed">机构账户提供更丰富的交易工具与更灵活的服务。如需开立机构账户，请联系客户经理。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'FundCustomers',
  metaInfo: {
    title: '基金客户 - 红土证券'
  },
  data() {
    return {
      defaultTradingUrl: 'https://redland.trade.wbrks.com/Webtrading',
      externalLinks: {
        openAccount: '',
        privilegeLearnMore: '',
        investorTools: '',
        techLearnMore: ''
      },
      currentTechTab: 'cloud',
      techTabs: [
        { key: 'cloud', label: '严谨的基金投研与风控体系' },
        { key: 'order', label: '专业投研团队' },
        { key: 'market', label: '专业定制化的资产管理服务' },
        { key: 'funds', label: '透明化费用结构' }
      ],
      techContent: {
        cloud: {
          cardLeft: { title: '深度基本面研究为体，系统量化模型为用', subtitle: '行业首创' },
          cardRight: { title: '全流程风险管理', subtitle: '覆盖资产、组合、合规三个维度的动态风险管理' },
          intro: '基本面研究洞察价值，量化方法验证逻辑，全流程风控守护安全',
          advantages: [
            '投研团队深度融合宏观研判、行业分析与量化模型，构建科学的基金投资组合。',
            '建立涵盖投前尽调、投中监控、投后回顾的风控机制，严格把控投资风险。',
            '所有基金产品均依规设立与管理，运作透明，严格遵循香港证监会相关指引。'
          ]
        },
        order: {
          cardLeft: { title: '专业投研团队', subtitle: '历经多轮市场周期，具备应对复杂市场环境的能力与定力' },
          cardRight: { title: '多元化的背景构成', subtitle: '通过不同背景与视角的碰撞，持续提升整体投研的前瞻性与稳定性' },
          intro: '团队的国际背景、跨领域经验与系统化研究方法，共同构成我们为客户创造价值的核心依托',
          advantages: [
            '历经多个完整市场周期考验，形成了成熟的投资哲学和风险控制理念。',
            '具备国际化的投资视野和本地市场的深度认知，多元化背景，把握全球投资机会',
            '团队稳定性在业内处于领先水平，团队稳定性在业内处于领先水平'
          ]
        },
        market: {
          cardLeft: { title: '定期投资汇报与检视', subtitle: '定期向您呈现资产表现、风险变化与配置动态，助您随时掌握投资进展' },
          cardRight: { title: '一站式基金行政支持', subtitle: '通过标准化流程与数字化工具，提升服务响应效率' },
          intro: '在投资端提供透明及时的业绩沟通，在运营端提供稳健周全的事务支持',
          advantages: [
            '提供透明的资产净值报告、持仓分析与绩效回顾，保持沟通顺畅。',
            '涵盖账户设立、资金托管、交易执行、税务申报等全流程服务。',
            '根据客户风险偏好、流动性需求与长期目标，定制专属投资策略。'
          ]
        },
        funds: {
          cardLeft: { title: '管理费', subtitle: '用于覆盖投资管理、研究运营及客户服务等成本' },
          cardRight: { title: '业绩报酬', subtitle: '按超额收益的一定比例提取报酬' },
          intro: '收费水平与服务质量相匹配，业绩报酬机制确保我们与您利益一致',
          advantages: [
            '管理费根据管理规模设定固定比例，公开透明',
            '部分产品设有业绩提成，仅当收益率超越约定基准时按超额部分计提',
            '我们坚持费用透明、公平合理的原则'
          ]
        }
      }
    }
  },
  methods: {
    resolveLink(url) {
      if (typeof url === 'string' && url.trim()) {
        return url.trim();
      }
      return this.defaultTradingUrl;
    }
  },
  computed: {
    currentTech() {
      return this.techContent[this.currentTechTab] || this.techContent.cloud
    }
  }
}
</script>

<style scoped>
.hero-banner {
  position: relative;
  height: 40vh;
  min-height: 600px;
  overflow: hidden;
  background:url("@/assets/487585e4e8bd59c74850991ff73e9fe8.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.banner-content { position: absolute; top: 50%; left: 15%; transform: translateY(-50%); z-index: 10; }
.text-content { text-align: left; }
.brand-name { font-size: 1.5rem; font-weight: 300; color: white; margin-bottom: 0.5rem; letter-spacing: 0.1em; }
.main-title { font-size: 3.5rem; font-weight: 700; color: white; margin-bottom: 2rem; letter-spacing: 0.05em; line-height: 1.1; }
.cta-button { background: transparent; color: white; border: 2px solid white; padding: 0.75rem 2rem; font-size: 1rem; font-weight: 500; border-radius: 4px; cursor: pointer; transition: all 0.3s ease; letter-spacing: 0.05em; }
.cta-button:hover { background: white; color: #1e3a8a; transform: translateY(-2px); box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2); }
@media (max-width: 1024px) { .hero-banner { height: 80vh; min-height: 500px; } .main-title { font-size: 2.5rem; } .banner-content { left: 10%; } }
@media (max-width: 768px) { .hero-banner { height: 70vh; min-height: 400px; } .main-title { font-size: 2rem; } .brand-name { font-size: 1.2rem; } .banner-content { left: 8%; } .cta-button { padding: 0.6rem 1.5rem; font-size: 0.9rem; } }
@media (max-width: 640px) { .hero-banner { height: 60vh; min-height: 350px; } .main-title { font-size: 1.8rem; } .brand-name { font-size: 1rem; } .banner-content { left: 5%; } }

.nav-tab { padding: 0.75rem 1rem; font-weight: 500; color: #6b7280; border-bottom: 2px solid transparent; transition: all 0.2s; position: relative; cursor: pointer; background: none; border: none; }
.nav-tab.active { color: #1f2937; border-bottom-color: #1f2937; }
.nav-tab:hover { color: #374151; }

.tech-card { background: #ffffff; border: 1px solid #e5e7eb; border-radius: 0.75rem; }
.tech-card-body { padding: 1.5rem; text-align: center; }
.tech-title { font-size: 1.75rem; font-weight: 700; color: #ef7c5b; }
.tech-subtitle { margin-top: 0.25rem; color: #9ca3af; }
.advantage-icon-box { width: 48px; height: 48px; min-width: 48px; display: inline-flex; align-items: center; justify-content: center; border: 2px dashed #ef7c5b; border-radius: 12px; margin-right: 12px; background: #fff7f4; }
.learn-more-btn { background: #ef7c5b; color: #ffffff; padding: 0.6rem 1.5rem; border: none; border-radius: 1.5rem; font-weight: 600; }
</style>
